import { TranslatePipe } from '../../filters/translate.pipe';
import { SymptomCheckInterviewComponent } from '../../components/symptom-check/symptom-check-interview.component';
import { SymptomCheckResultsComponent } from '../../components/symptom-check/symptom-check-results.component';
import { SymptomCheckSymptomsComponent } from '../../components/symptom-check/symptom-check-symptoms.component';
import { SymptomCheckFactorsComponent } from '../../components/symptom-check/symptom-check-factors.component';
import { SymptomCheckPatientComponent } from '../../components/symptom-check/symptom-check-patient.component';
import { SymptomCheckIntroductionComponent } from '../../components/symptom-check/symptom-check-introduction.component';
import { SymptomCheckRegionsComponent } from '../../components/symptom-check/symptom-check-regions.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import SymptomCheckService from '../../services/symptom-check.service';
import RestService from '../../services/core-rest.service';
import PreVisitRecordTicketForPersonService from '../../services/pre-visit-record-ticket-for-person.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'symptom-check',
	templateUrl: './symptom-check.component.html',
	imports: [
		CommonModule, TranslatePipe, SymptomCheckInterviewComponent, SymptomCheckResultsComponent, 
		SymptomCheckSymptomsComponent, SymptomCheckFactorsComponent, SymptomCheckPatientComponent, 
		SymptomCheckIntroductionComponent, SymptomCheckRegionsComponent, FormsModule, RouterLink
	]
})
export default class SymptomCheckView implements OnInit, OnDestroy {
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private restService: RestService = inject(RestService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('symptomCheck').then(() => {
			if (!this.vm.parentCategoryConfig) {
				this.restService.getPreVisitTicketConfig({ 'parentCategory': 'NEW_HEALTH_PROBLEM' })
					.then((parentCategoryConfig) => {
						this.vm.parentCategoryConfig = parentCategoryConfig;
						this.validateAccess();
					});
			} else {
				this.validateAccess();
			}
		});
	}
	
	ngOnDestroy() {
		if (this.vm.currentStepWatcher) {
			this.angularHelperService.cancelInterval(this.vm.currentStepWatcher);
		}
	}
	
	onResolve() {
		this.vm.interview = this.symptomCheckService.getInterview();
		this.vm.isRecordTicketForPersonInWorkerView = !!this.preVisitRecordTicketForPersonService.getPatient()
			&& this.session.getSession().user.businessUser;
		this.vm.steps = this.symptomCheckService.getValidatedSteps();
		this.vm.id = this.angularRoutingHelperService.getCurrentRouteParam('id');
		if (!this.vm.id) {
			this.vm.id = this.symptomCheckService.getStepIds()[0];
		}
		this.vm.open = false;
		this.vm.queryParams = this.angularRoutingHelperService.getQueryParams() || null;
		
		//this.angularStateHelperService.scopeWM(this, 'this.vm.interview', this.handleInterviewUpdate, true);
		//this.angularStateHelperService.scopeWF(this, () => { return this.symptomCheckService.getCurrentStepId(); }, this.handleStepChange);
		this.vm.currentStepId = this.vm.id;
		this.vm.currentStepWatcher = this.angularHelperService.createInterval(() => {
			var newCurrentStepId = this.symptomCheckService.getCurrentStepId();
			// console.log("SC", this.vm.currentStepId, newCurrentStepId);
			if (!this.angularHelperService.equals(this.vm.currentStepId, newCurrentStepId)) {
				this.handleStepChange(newCurrentStepId, this.vm.currentStepId);
				this.vm.currentStepId = newCurrentStepId;
			}
		}, 200);
		
		this.vm.handleNavigation = this.handleNavigation;
		this.vm.openSummaryDialog = this.openSummaryDialog;
		this.vm.endInterviewNotPossibleOnPages = this.endInterviewNotPossibleOnPages;
	}
	
	interviewChanged(newInterview) {
		this.vm.interview = newInterview;
		this.handleInterviewUpdate(this.vm.interview);
	}
	
	validateAccess() {
		var stepIds: any = this.symptomCheckService.getStepIds();
		var currentId: any = this.angularRoutingHelperService.getCurrentRouteParam('id');
		var stepIndex: any = currentId ? stepIds.indexOf(currentId) : 0;

		
		if (stepIndex === -1) {
			this.angularRoutingHelperService.setPath(['symptom-check', stepIds[0]], false, true);
			return;
		}

		var steps: any = this.symptomCheckService.getValidatedSteps().slice(0, stepIndex);
		
		var invalidIndex: any = steps.map((step) => { return !!step.isValid }).indexOf(false);
		if (invalidIndex !== -1) {
			var newStep = invalidIndex > 0 ? invalidIndex - 1 : 0;
			this.angularRoutingHelperService.setPath(['symptom-check/', stepIds[newStep]], false, true);
			return;
		}
		
		this.symptomCheckService.setStep(stepIndex);
		this.onResolve();
	}
	
	handleInterviewUpdate(newInterview) {
		this.symptomCheckService.updateInterview(newInterview);
		this.vm.steps = this.symptomCheckService.getValidatedSteps();
	}
	
	handleStepChange(nv, ov) {
		if (!this.angularHelperService.equals(nv, ov)) {
			if (ov === 'results') {
				this.vm.interview = {};
				nv = this.symptomCheckService.getStepIds[0];
			}
			
			this.vm.id = nv;
			this.angularRoutingHelperService.setPathAndKeepQueryParams(['symptom-check/', nv]);
		}
	}
	
	handleNavigation(e, index) {
		if (e && e.preventDefault) {
			e.preventDefault();
		}
		
		if (this.vm.id === 'results') {
			this.vm.interview = {};
			index = 0;
		}
		
		this.symptomCheckService.setStep(index);
	}
	
	openSummaryDialog() {
		this.vm.interview.open = !this.vm.interview.open;
		
		var data = {};
		data['interview'] = this.vm.interview;
		data['config'] = this.vm.parentCategoryConfig;
		
		this.angularBroadcastHelperService.rootBroadcast("togglePreVisitFinishDrawer", data);
	}
	
	endInterviewNotPossibleOnPages() {
		return window.location.hash.includes('/regions') || window.location.hash.includes('/symptoms')
			|| window.location.hash.includes('/factors') || window.location.hash.includes('/patient')
			|| window.location.hash.includes('/introduction') || window.location.hash.includes('/results');
	}
	
}